module.exports = __webpack_public_path__ + "static/media/pics9.ffe416aa.png";